import React from "react";
import styled from "styled-components";

const fmtRelativeTime = (isoDate) => {
  if (!isoDate) return "—";
  const d = new Date(isoDate);
  if (isNaN(d.getTime())) return "—";
  const diffMs = Date.now() - d.getTime();
  const diffH = Math.floor(diffMs / 3600000);
  const diffD = Math.floor(diffMs / 86400000);
  if (diffMs < 0) return "—";
  if (diffH < 1) return "<1h";
  if (diffH < 24) return `hace ${diffH}h`;
  if (diffD < 7) return `hace ${diffD}d`;
  return `hace ${Math.floor(diffD / 7)}sem`;
};

const PlayerStats = ({ stats, loading }) => {
  if (loading) {
    return (
      <Wrapper>
        <Grid>
          {[...Array(8)].map((_, i) => (
            <StatCard key={i}>
              <StatValue $loading>Skeleton</StatValue>
            </StatCard>
          ))}
        </Grid>
      </Wrapper>
    );
  }

  if (!stats) return null;

  const { player, rank, totalPlayers, eloChange24h, eloChange7d } = stats;

  const items = [
    {
      label: "ELO ACTUAL",
      value: player.aoe2CurrentElo ?? "—",
      color: "var(--v-mint)",
    },
    {
      label: "ELO MEDIO",
      value: player.aoe2AvgElo ?? "—",
    },
    {
      label: "ELO MÁXIMO",
      value: player.aoe2MaxElo ?? "—",
    },
    {
      label: "RANKING",
      value: rank ? `#${rank} / ${totalPlayers}` : "—",
    },
    {
      label: "ELO 24H",
      value: eloChange24h !== null && eloChange24h !== undefined
        ? `${eloChange24h >= 0 ? "+" : ""}${eloChange24h}`
        : "—",
      change: eloChange24h,
    },
    {
      label: "ELO 7D",
      value: eloChange7d !== null && eloChange7d !== undefined
        ? `${eloChange7d >= 0 ? "+" : ""}${eloChange7d}`
        : "—",
      change: eloChange7d,
    },
    {
      label: "PARTIDAS",
      value: player.aoe2RatingsCount ?? "—",
    },
    {
      label: "ÚLT. PARTIDA",
      value: fmtRelativeTime(player.aoe2LastGameDate),
    },
  ];

  return (
    <Wrapper>
      <Grid>
        {items.map((item) => (
          <StatCard key={item.label}>
            <StatLabel>{item.label}</StatLabel>
            <StatValue
              $positive={item.change > 0}
              $negative={item.change < 0}
              $color={item.color}
            >
              {item.value}
            </StatValue>
          </StatCard>
        ))}
      </Grid>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const StatCard = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 0.75rem;
  text-align: center;
`;

const StatLabel = styled.div`
  font-family: var(--v-font-mono);
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--v-fg-muted);
  margin-bottom: 0.35rem;
`;

const StatValue = styled.div`
  font-family: var(--v-font-mono);
  font-size: 15px;
  font-weight: 700;
  color: ${({ $positive, $negative, $color }) =>
    $positive ? "var(--v-mint)" : $negative ? "var(--v-uv)" : $color || "var(--v-fg)"};
  opacity: ${({ $loading }) => $loading ? 0.1 : 1};
`;

export default PlayerStats;
